export default "__VITE_ASSET__7uqWi0tl__"